<header class="header">
  <div class="header-left">
    <!-- Mobile Menu Button (visible only on mobile) -->
    <button class="mobile-menu-button" (click)="toggleMobileMenu()" aria-label="Toggle menu">
      <lucide-angular [img]="Menu" [size]="24" color="#323232"></lucide-angular>
    </button>
    <div class="logo-container" (click)="navigateToDashboard()">
      <img class="logo-icon" src="assets/Botmaa-logo.png" alt="BotMaa Logo" />
    </div>
  </div>
  <div class="header-right">
    <div class="notification">
      <span class="notif-bell" (click)="toggleNotifications($event)">
        <i class="material-icons">notifications</i>
        @if(unreadCount > 0){<span class="notification-badge">
          {{ unreadCount > 99 ? '99+' : unreadCount }}
        </span>}
      </span>
      <!-- Notification Popup Component -->
      @if(showNotifications){<app-notifications-popup
        [notifications]="notifications"
        (closePopup)="closeNotifications()"
        (markAllAsRead)="markAllAsRead()"
      >
      </app-notifications-popup>}
    </div>
    <div class="user-profile">
      @if (userProfileLoading) {
        <span class="user-name loading-name">
          <span class="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </span>
      } @else {
        <span class="user-name">{{ displayName }}</span>
      }
      <span class="profile-avatar">
        <app-profile-menu></app-profile-menu>
      </span>
    </div>
  </div>
</header>

<!-- Mobile Menu Component -->
<app-mobile-menu [isOpen]="mobileMenuOpen" (closeMenu)="closeMobileMenu()"></app-mobile-menu>
